export default __webpack_public_path__ + "images/d4a970dde86e49e5c3304243da0f891f.png";